import { notify } from 'utils/reduxUtils';

export const types = {
  FINALIZE_MODAL_OPEN: 'modals/finalizeModal/FINALIZE_MODAL_OPEN',
  FINALIZE_MODAL_CLOSE: 'modals/finalizeModal/FINALIZE_MODAL_CLOSE',
  FINALIZE_MODAL_INIT_SUCCESS:
    'modals/finalizeModal/FINALIZE_MODAL_INIT_SUCCESS',
  FINALIZE_MODAL_INIT_ERROR: 'modals/finalizeModal/FINALIZE_MODAL_INIT_ERROR',
  EMAIL_NOTIFICATION_SETTINGS_RETRIEVE_SUCCESS:
    'modals/finalizeModal/EMAIL_NOTIFICATION_SETTINGS_RETRIEVE_SUCCESS',
  EMAIL_NOTIFICATION_SETTINGS_RETRIEVE_ERROR:
    'modals/finalizeModal/EMAIL_NOTIFICATION_SETTINGS_RETRIEVE_ERROR',
};

export const finalizeModal = {
  open: ({ isResend, quoteId }) => ({
    type: types.FINALIZE_MODAL_OPEN,
    payload: { isResend, quoteId },
  }),
  close: () => ({
    type: types.FINALIZE_MODAL_CLOSE,
  }),
};

export const finalizeModalInit = {
  success: ({
    emailNotificationSettings,
    emailTemplates,
    isResend,
    quoteHeader,
    quoteItems,
    shippingInfo,
  }) => ({
    type: types.FINALIZE_MODAL_INIT_SUCCESS,
    payload: {
      emailNotificationSettings,
      emailTemplates,
      isResend,
      quoteHeader,
      quoteItems,
      shippingInfo,
    },
  }),
  error: () =>
    notify(
      (error) => ({
        type: types.EMAIL_NOTIFICATION_SETTINGS_RETRIEVE_ERROR,
        payload: error,
      }),
      'Failed to fetch email notification settings.',
    ),
};

export const emailNotificationSettingsRetrieve = {
  error: () =>
    notify(
      (error) => ({
        type: types.EMAIL_NOTIFICATION_SETTINGS_RETRIEVE_ERROR,
        payload: error,
      }),
      'Failed to fetch email notification settings.',
    ),
  success: ({ emailNotificationSettings }) => ({
    type: types.EMAIL_NOTIFICATION_SETTINGS_RETRIEVE_SUCCESS,
    payload: { emailNotificationSettings },
  }),
};

export const receiveEmailNotificationSettings = ({
  emailNotificationSettings,
}) => ({
  type: types.EMAIL_NOTIFICATION_SETTINGS_RECEIVE,
  payload: { emailNotificationSettings },
});
